import { Box2d, TLShapeId, Vec2d, track, useEditor, useTransform } from '@tldraw/tldraw'
import { useRef } from 'react'
import { MaskShape } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'
import { MaskHandles } from './MaskHandles'
import { getContentBounds } from 'components/VisualStudioPlayground/Shapes/MaskShape/helpers'

const MaskSelectionForeground = track(() => {
  const editor = useEditor()
  const rSvg = useRef<SVGSVGElement>(null)

  let maskingShape: MaskShape | undefined
  const maskingShapeId = editor.getCurrentPage().meta.maskingShapeId as TLShapeId | undefined
  if (maskingShapeId) {
    maskingShape = editor.getShape<MaskShape>(maskingShapeId)
  }
  let maskingBounds
  if (maskingShape) {
    const parent = editor.getShapeParent(maskingShapeId)
    const parentPosition = parent ? new Vec2d(parent.x, parent.y) : new Vec2d(0, 0)
    maskingBounds = Box2d.From(getContentBounds(maskingShape)).translate(parentPosition)
  }
  useTransform(rSvg, maskingBounds?.x, maskingBounds?.y, 1, editor.getSelectionRotation())
  const showMaskHandles = editor.isInAny(
    'select.mask.idle',
    'select.mask.pointing_content',
    'select.mask.translating_content',
    'select.pointing_mask_handle',
    'select.masking',
  )

  if (!showMaskHandles || !maskingBounds) {
    return null
  }

  return (
    <svg className="tl-overlays__item tl-selection__fg tl-svg-context" data-testid="mask-handles">
      <g ref={rSvg}>
        <MaskHandles width={maskingBounds.w} height={maskingBounds.h} rotation={0} />
      </g>
    </svg>
  )
})

export { MaskSelectionForeground }
